export default __webpack_public_path__ + "static/media/Pizzabellavita.49f5dbb7.jpeg";